<template>
  <div id="app">
    <preloader v-if="preloading" @loaded="dataPreloaded"/>
    <template v-else>
      <div class="fixed flex items-center justify-between w-full z-50" id="header">
        <img src="/img/logo_new.svg" id="logo" alt="Iliana Yonkova Studio" @click="goHomeOrTop" class="cursor-pointer">
        <!--  desktop nav -->
<!--        <div class="hidden md:block desktop-nav">-->
<!--          <a @click="goHomeOrTop" :class="{ 'active':isActive('/')}" class="cursor-pointer text-xs text-gray-600 hover:text-primary lg:mr-5 md:mr-2">-->
<!--            {{ T('home') }}-->
<!--          </a>-->
<!--          <router-link to="/about" :class="{ 'active':isActive('/about')}" class="text-xs text-gray-600 hover:text-primary lg:mr-5 md:mr-2">-->
<!--            {{ T('about') }}-->
<!--          </router-link>-->
<!--          <router-link to="/projects" :class="{ 'active':isActive('/projects')}" class="text-xs text-gray-600 hover:text-primary lg:mr-5 md:mr-2">-->
<!--            {{ T('projects') }}-->
<!--          </router-link>-->
<!--          <router-link to="/contacts" :class="{ 'active':isActive('/contacts')}" class="text-xs text-gray-600 hover:text-primary lg:mr-5 md:mr-2">-->
<!--            {{ T('contacts') }}-->
<!--          </router-link>-->
<!--          <span class="ml-1 cursor-pointer" @click="$store.commit('setLocale','en')">-->
<!--          <span :class="locale()==='en' ? 'text-primary':'text-gray-600'" class="text-xs  hover:text-primary">EN</span>-->
<!--        </span>-->
<!--          |-->
<!--          <span class="cursor-pointer" @click="$store.commit('setLocale','bg')">-->
<!--          <span :class="locale()==='bg' ? 'text-primary':'text-gray-600'" class="text-xs  hover:text-primary">BG</span>-->
<!--        </span>-->
<!--        </div>-->
      </div>


      <!--  mobile nav -->
      <div :class="{'active':$store.state.isActiveNav}" class="menu-icon z-50"
           @click="$store.commit('toggleNav')">
        <span class="menu-icon__line menu-icon__line-left"></span>
        <span class="menu-icon__line"></span>
        <span class="menu-icon__line menu-icon__line-right"></span>
      </div>

      <div :class="{'active':$store.state.isActiveNav}" class="nav z-40 ">
        <Navigation></Navigation>
      </div>

      <transition name="fade" mode="out-in">
        <router-view :key="$route.fullPath"></router-view>
      </transition>
    </template>
  </div>
</template>


<script>


import Preloader from "./components/Preloader";

import Navigation from "./components/Navigation";

export default {
  components: {Preloader,Navigation},
  data() {
    return {
      preloading: true,
      showNav: false,
      set_scroll: false
    }
  },
  computed: {},
  watch: {},
  methods: {
    isActive(path){
      return this.$route.path===path;
    },
    dataPreloaded(data) {
      this.preloading = false;
    },
    goHomeOrTop(){
      if (this.$route.name === 'home') {
        document.getElementById('viewer').scrollTo({top:0,behavior:'smooth'});
      }else{
        this.$router.push('/');
      }
    }
  },
  mounted() {
    window.addEventListener('popstate', (event) => {


    });
  },
  beforeDestroy() {
    localStorage.clear();
  }
}
</script>


<style lang="scss">
#header {
  height: 35px;
  //on small phone smaller height
  @media (max-width: 680px) {
    height: 30px;
  }
}

#logo{
  height: 70px;
  padding-left: 25px;
  margin-top: 20px;

  //on small phone smaller height
  @media (max-width: 680px) {
    height: 50px;
    padding-left: 15px;
    margin-top: -8px;
  }
}


#header{
  top:30px;
  //background: black;
}

a.active{
  @apply text-white;
}
</style>
